<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute">
        <img class="box-img" src="../assets/banner2.png" />
        <div class="box-font">采购公告</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px">
      <div style="display: flex; margin-top: 40px">
        <!-- <div>
          <leftmenu :value='Category' :list='purchase_menulist' @datashow =contentshow ></leftmenu>-->
        <!--登录-->
        <!--  <leftlogin :formData.sync="form"></leftlogin>
        </div> -->
        <div style="margin-left: 20px; width: 100%; border: 1px solid #cccccc">
          <div style="width: 100%; height: 90px; justify-content: center; display: flex; padding-top: 30px">
            <input id="zb_title" type="text" placeholder="请输入关键词（招标编号或项目名称）"
              style="text-indent: 10px; width: 400px; height: 42px; border-radius: 5px 0px 0px 5px; border: 1px solid #df3e3e" />
            <a @click="searchzb_title()" style="
                background-color: #df3e3e;
                color: #ffffff;
                width: 100px;
                height: 42px;
                border-radius: 0px 5px 5px 0px;
                text-align: center;
                padding-top: 10px;
              ">搜索</a>
          </div>
          <el-table :data="this.tenderslist" style="width: 100%; font-size: 18px" :row-style="{}"
            :cell-style="{ 'font-size': '16px', padding: '20px 0px' }" :header-row-style="{}" :fit="true">
            <el-table-column prop="Subtitle" label="招标编号" width="200"> </el-table-column>
            <el-table-column prop="Title" label="招标项目" min-width="170">
              <template slot-scope="scope">
                <router-link exact :title="scope.row.Title"
                  :to="'/purchasedetail?type=' + scope.row.Type + '&id=' + scope.row.Id">{{
              scope.row.Title
            }}</router-link>
              </template>
            </el-table-column>
            <el-table-column prop="question" label="答疑" width="60" align="center">
              <template slot-scope="scope">
                <router-link v-if="scope.row.question" exact
                  :to="'/purchasedetail?type=' + scope.row.Type + '&id=' + scope.row.Id + '&Category=2'"
                  style="color: red">答疑</router-link>
                <label v-else>答疑</label>
              </template>
            </el-table-column>
            <el-table-column prop="replenish" label="补充公告" width="100" align="center">
              <template slot-scope="scope">
                <router-link v-if="scope.row.replenish" exact
                  :to="'/purchasedetail?type=' + scope.row.Type + '&id=' + scope.row.Id + '&Category=3'"
                  style="color: red">补充公告</router-link>
                <label v-else>补充公告</label>
              </template>
            </el-table-column>
            <el-table-column prop="chang" label="更改公告" width="100" align="center">
              <template slot-scope="scope">
                <router-link v-if="scope.row.chang" exact
                  :to="'/purchasedetail?type=' + scope.row.Type + '&id=' + scope.row.Id + '&Category=4'"
                  style="color: red">更改公告</router-link>
                <label v-else>更改公告</label>
              </template>
            </el-table-column>
            <el-table-column prop="zb" label="中标公告" width="100" align="center">
              <template slot-scope="scope">
                <router-link v-if="scope.row.Win" exact
                  :to="'/purchasedetail?type=' + scope.row.Type + '&id=' + scope.row.Id + '&Category=5'"
                  style="color: red">中标公告</router-link>
                <label v-else>中标公告</label>
              </template>
            </el-table-column>
            <el-table-column prop="PublishTime" label="发布时间" width="180" align="center">
              <template slot-scope="scope">
                <label> {{ scope.row.PublishTime != "0001-01-01 00:00:00" ? scope.row.PublishTime : "" }}</label>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination">
        <el-pagination class="my-el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 15, 20]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" :small="false">
        </el-pagination>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "purchasenotice",
  components: { leftmenu, leftlogin },
  data() {
    return {
      isShow: true,
      tenderslist: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      purchase_menulist: [],
      Category: "",
      form: {
        name: "",
        pass: "",
        type: "",
      },
      search: "",
    };
  },
  created() {
    var that = this;
    that.search = that.$route.query.search;
    that.Category = that.$route.query.id;
    var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];
    that.purchase_menulist = menulist.filter(function (item) {
      return item.Word_Group_Key == "IndustryType";
    });
    if (that.Category) {
      var list = that.purchase_menulist.filter(function (item) {
        return item.Word_Value == that.Category;
      });
      if (list.length > 0) {
        that.getData();
      }
    } else that.getData();
  },
  methods: {
    getData() {
      var that = this;
      var params = {
        PageIndex: that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: "p.PublishTime desc",
        Type: that.Category,
        Multiple: that.search,
      };
      that.$api.get("/Notice/Get", params, (r) => {
        that.tenderslist = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(size) {
      console.log(size, "size");
      this.pagesize = size;
      this.getData();
    },
    handleCurrentChange(currentPage) {
      console.log(currentPage, "currentPage");
      this.currentPage = currentPage;
      this.getData();
    },
    contentshow(item) {
      var that = this;
      that.Category = item.Word_Value;
      that.getData();
      return false;
    },
    searchzb_title() {
      this.search = document.getElementById("zb_title").value;
      this.getData();
    },
  },
  watch: {
    $route(to) {
      var that = this;
      that.search = to.query.search;
      that.Category = to.query.id;
      if (that.Category) {
        var list = that.purchase_menulist.filter(function (item) {
          return item.Word_Value == that.Category;
        });
        if (list.length > 0) {
          that.getData();
        }
      } else that.getData();
    },
  },
  computed: {},
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
  margin-top: 10px;
}

.frame-border {
  width: 204px;
  border: 1px solid #eeeeee;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}
</style>
